export default __webpack_public_path__ + "static/mentions-2-dark-7e4396df200849f6d54be5005990867f.png";